import React from "react";

function Amount({ formData }: any) {
  return (
    <tfoot className="bg-slate-50 dark:bg-slate-700/50">
      <tr>
        <td colSpan={5} className="px-3 py-2 text-xs font-medium text-slate-600 dark:text-slate-400">Newly Added Charges</td>
        <td className="px-3 py-2 text-xs font-semibold text-slate-800 dark:text-slate-200">Rs {formData.total}</td>
        <td></td>
      </tr>
      <tr>
        <td colSpan={5} className={`px-3 py-2 text-xs font-medium ${formData.lastDue > 0 ? "text-red-600 dark:text-red-400" : "text-emerald-600 dark:text-emerald-400"}`}>
          {formData.lastDue > 0 ? "Previous Dues" : "Advance Received"}
        </td>
        <td className={`px-3 py-2 text-xs font-semibold ${formData.lastDue > 0 ? "text-red-600 dark:text-red-400" : "text-emerald-600 dark:text-emerald-400"}`}>
          Rs {Math.abs(formData.lastDue)}
        </td>
        <td></td>
      </tr>
      <tr className="bg-indigo-50 dark:bg-indigo-900/30">
        <td colSpan={5} className="px-3 py-2 text-xs font-bold text-indigo-700 dark:text-indigo-300">Total Payable</td>
        <td className="px-3 py-2 text-sm font-bold text-indigo-700 dark:text-indigo-300">Rs {formData.payable}</td>
        <td></td>
      </tr>
    </tfoot>
  );
}

export default Amount;
